import React from "react";

import { formatDateOnly } from "../../../../utils/datetime";
import {
  CardCta,
  CardNeutralState,
  CheckRow,
  FolderIcon,
  MetaRow,
  OverviewCard,
} from "./overviewUi";

/**
 * "Einzug & Dokumente".
 *
 * WHY ONLY ONE CHECK ROW (O1a). The reference design shows three: Mietvertrag,
 * Übergabeprotokoll, Schlüsselquittung. All three exist in the data model with a
 * real signature timestamp — but only the inspection is loaded at PAGE level
 * (`useTenantInspections`). `RentalContract` and `KeyReceipt` are fetched INSIDE
 * `RentalContractSection` / `HandoverSection`, once per tenancy, and lifting
 * them here would add requests this slice is explicitly not allowed to add.
 *
 * Rather than guess those two states — or print a check whose date nobody
 * proved — the card states what the page can prove and sends the reader to the
 * tab that owns the rest. The other two rows belong to the O1b overview
 * contract, which is where the per-tenancy fetches get replaced by one batched
 * read.
 *
 * `signed_at` is the tenant's signature. `finalized_at` is only the edit lock
 * and is NOT read as "unterzeichnet".
 */
export default function MoveInDocumentsCard({
  protocol,
  documentCount,
  hasTenancy,
  onOpen,
}) {
  return (
    <OverviewCard
      title="Einzug & Dokumente"
      icon={<FolderIcon />}
      accent="blue"
      testId="overview-documents-card"
      footer={
        onOpen ? (
          <CardCta onClick={onOpen} testId="overview-documents-cta">
            Alle Dokumente öffnen
          </CardCta>
        ) : null
      }
    >
      {hasTenancy ? (
        <div className="divide-y divide-border">
          <CheckRow
            label="Übergabeprotokoll unterzeichnet"
            done={Boolean(protocol?.signedAt)}
            date={
              protocol?.signedAt ? formatDateOnly(protocol.signedAt) : null
            }
            testId="overview-doc-protocol"
          />
          <MetaRow
            label="Hinterlegte Dokumente"
            value={
              Number.isFinite(Number(documentCount))
                ? String(documentCount)
                : null
            }
          />
        </div>
      ) : (
        <CardNeutralState
          testId="overview-documents-empty"
          text="Ohne laufendes Mietverhältnis gibt es keine Einzugsdokumente."
        />
      )}

      <p className="m-0 pt-3 text-[11.5px] leading-snug text-muted-foreground">
        Mietvertrag und Schlüsselquittung stehen im Tab «Mietverhältnisse».
      </p>
    </OverviewCard>
  );
}
